<!-- Sized for the global search's result table, and every source gets it: one dialog size across the picker's
     modes, rather than the dialog resizing as the tabs along the top are clicked. -->
<ui-modal [modalTitle]="isReplace ? 'Replace Product' : 'Select Product'" [size]="'xxl'" [fullHeight]="true">
	<button *ngFor="let s of sources" class="btn border-0 mr-2" [ngClass]="{ 'btn-primary': source === s.id, 'btn-outline-secondary': source !== s.id, 'd-none': !s.show }" (click)="selectSource(s.id)" [appTutorial]="s.tutorial" ui-modal-header><i class="{{s.icon}} mr-2"></i>{{s.description}}</button>
	<button *ngIf="isMulti" class="btn border-0 mr-2" [ngClass]="{ 'btn-primary': source === 'selected', 'btn-outline-secondary': source !== 'selected' }" (click)="selectSource('selected')" ui-modal-header>Selected <ui-button-badge>{{multiSelectList.length}}</ui-button-badge></button>

	<ng-container *ngIf="source === 'global-search'">
		<div class="d-flex flex-row mt-n4 h-100 global-search-body">
			<div class="d-flex flex-column border-right">
				<app-filter
					(filterChanged)="productSearch.applyFilters($event)"
					(scopeChanged)="productSearch.scopeChanged($event)"
					[sections]="productSearch.filterSections"
					[segments]="productSearch.segments"
					[totalCategories]="productSearch.totalCategories"
					[scope]="productSearch.scope"
					[selected]="productSearch.selectedFilters"
					[loading]="productSearch.loading"
					[treeLoading]="productSearch.browseLoading"></app-filter>
			</div>

			<div class="d-flex flex-column flex-weight-1">
				<div class="d-flex flex-row justify-content-end border-bottom">
					<div class="input-group p-3 search-box" #globalSearchBox>
						<div class="input-group-prepend">
							<span class="input-group-text"><i class="wq wq-search"></i></span>
						</div>
						<!-- type="search" gives the same native clear button every other search box in the app uses. -->
						<input *ngIf="!!modal?.isOpen" type="search" class="form-control" placeholder="Search" [(ngModel)]="productSearch.query" (input)="productSearch.onQueryInput()" (keyup.enter)="productSearch.search()" (focus)="productSearch.showRecentSearches = true" autocomplete="chrome-off" spellcheck="false">
						<div class="input-group-append">
							<button type="button" class="btn btn-primary px-4" [disabled]="!productSearch.canSearch" (click)="productSearch.search()">Search</button>
						</div>

						<div class="suggestions-overlay shadow bg-white border border-lightgrey rounded mt-n2" *ngIf="productSearch.showsRecentSearches">
							<div class="text-uppercase text-tiny text-secondary px-3 pt-3 pb-1">Recent searches</div>
							<div *ngFor="let recent of productSearch.recentSearches" class="px-3 py-2 selectable hoverable d-flex align-items-center" (click)="productSearch.recentSearch(recent)">
								<i class="wq wq-clock text-secondary mr-2"></i>
								<span class="text-dark flex-weight-1 text-truncate">{{recent}}</span>
							</div>
						</div>
					</div>
				</div>

				<!-- Nothing typed yet: offer the catalogue to browse rather than an empty table. -->
				<ng-container *ngIf="productSearch.browsing; else globalSearchResults">
					<div class="flex-weight-1 d-flex flex-column p-3 browse-view">
						<div class="text-uppercase text-tiny text-secondary mb-2">Browse</div>

						<div class="d-flex flex-row flex-weight-1">
							<div class="d-flex flex-column flex-weight-1">
								<!-- alwaysShowHeader so the card keeps its title while the counts are being fetched. -->
								<ui-card widget header="Browse categories" [headerDivider]="true" [wait]="!productSearch.browseLoading && productSearch.browseCategories" [alwaysShowHeader]="true" [padding]="false">
									<table class="table table-hover m-0">
										<tbody>
											<tr *ngFor="let category of productSearch.browseCategories" class="selectable" (click)="productSearch.browseCategory(category)">
												<td class="text-bold text-dark">{{category.category}}</td>
												<td class="text-secondary text-right nowrap">{{category.segment}}</td>
												<td class="text-secondary text-right nowrap">{{category.product_count | decimal:0}} results</td>
												<td class="shrink text-secondary"><i class="wq wq-angle-right"></i></td>
											</tr>
											<tr *ngIf="!productSearch.browseCategories?.length">
												<td class="text-secondary">No categories found.</td>
											</tr>
										</tbody>
									</table>
								</ui-card>
							</div>
						</div>
					</div>
				</ng-container>

				<ng-template #globalSearchResults>
					<ui-card widget class="flex-weight-1 results-card" [footer]="true" [wait]="productSearch.results" [customHeader]="true" [customHeaderDivider]="false" [headerDivider]="false">
						<!-- Result count and the chips live in the card header, so they stay put while the table scrolls. -->
						<div ui-card-custom-header>
							<div class="d-flex align-items-center flex-wrap">
								<span class="text-uppercase text-tiny text-secondary mr-2">products &middot; {{productSearch.totalGroups}}<span *ngIf="productSearch.approximate">+</span><span *ngIf="productSearch.term || productSearch.hasFilters"> {{productSearch.totalGroups === 1 ? 'result' : 'results'}}</span></span>

								<span *ngIf="productSearch.scope.segment" class="badge badge-lightergrey text-dark text-small font-weight-normal mr-2 px-2 py-1">
									{{productSearch.scope.segment}} <i class="wq wq-close selectable ml-1" (click)="productSearch.removeScope('segment')"></i>
								</span>
								<span *ngIf="productSearch.scope.category" class="badge badge-lightergrey text-dark text-small font-weight-normal mr-2 px-2 py-1">
									{{productSearch.scope.category}} <i class="wq wq-close selectable ml-1" (click)="productSearch.removeScope('category')"></i>
								</span>
								<span *ngIf="productSearch.scope.subcategories?.length" class="badge badge-lightergrey text-dark text-small font-weight-normal mr-2 px-2 py-1">
									{{productSearch.scope.subcategories.length}} {{productSearch.scope.subcategories.length === 1 ? 'subcategory' : 'subcategories'}} <i class="wq wq-close selectable ml-1" (click)="productSearch.removeScope('subcategories')"></i>
								</span>

								<span *ngFor="let chip of productSearch.filterChips" class="badge badge-lightergrey text-dark text-small font-weight-normal mr-2 px-2 py-1 d-inline-flex align-items-center">
									<span *ngIf="chip.color" class="label-dot rounded-circle mr-1" [style.background]="chip.color"></span>
									{{chip.label}} <i class="wq wq-close selectable ml-1" (click)="productSearch.removeFilter(chip)"></i>
								</span>
							</div>

							<div *ngIf="productSearch.capped" class="alert alert-warning py-2 mt-2 mb-0 text-small">
								Showing the first {{productSearch.results?.length}} of {{productSearch.totalGroups}}<span *ngIf="productSearch.approximate">+</span> matches &mdash; refine your search to narrow it down.
							</div>
						</div>

						<div *ngIf="productSearch.results" class="results-body results-scroll">
							<!-- No product panel here: the picker is for choosing a product, not for reading about one. -->
							<app-product-results
								[items]="productSearch.results"
								[pagination]="productSearch.pagination"
								[query]="productSearch.query"
								[canAdd]="true"
								[canOpenDetail]="false"
								[addedIds]="pickedProductIds"
								[addedProducts]="staysOpen ? addedProducts : []"
								[addLabel]="isReplace ? 'Replace' : 'Add'"
								[addedLabel]="isReplace ? 'Replace' : 'Added'"
								emptyText="No products found."
								(add)="addFromGlobalSearch($event)"></app-product-results>
						</div>

						<app-pagination [pagination]="productSearch.pagination" ui-card-footer></app-pagination>
					</ui-card>
				</ng-template>
			</div>
		</div>
	</ng-container>

	<ng-container *ngIf="source !== 'selected' && source !== 'global-search'">
		<div *ngIf="categories.length && app.orgInfo?.role.update_toolkit" class="form-horizontal">
			<ui-form direction="inline">
				<ui-form-control label="Add to subsystem" class="flex-weight-1">
					<select class="custom-select" [(ngModel)]="selectedCategory" [disabled]="staysOpen" [ngbTooltip]="staysOpen ? 'You cannot add products to the Subsystem Toolkit in multi-select mode' : null">
						<option [ngValue]="null">Unassigned</option>
						<optgroup *ngFor="let g of categoryGroups" label="{{g.description}}">
							<option *ngFor="let item of g.categories" [ngValue]="item.id">{{item.description}}</option>
						</optgroup>
					</select>
				</ui-form-control>
				<ui-form-control [ngbTooltip]="staysOpen ? 'You cannot add products to the Subsystem Toolkit in multi-select mode' : null">
					<label class="custom-control custom-checkbox">
						<input type="checkbox" class="custom-control-input" [(ngModel)]="addToToolkit" [disabled]="staysOpen">
						<span class="custom-control-label">Add to subsystem toolkit</span>
					</label>
				</ui-form-control>
			</ui-form>
			<hr class="mt-0">
		</div>

		<div class="d-flex" [ngClass]="{ 'invisible': !(source === 'my-products' || catalogues?.length) }">
			<div class="input-group mb-2 flex-weight-1">
				<div class="input-group-prepend"><span class="input-group-text"><i class="wq wq-search"></i></span></div>
				<input *ngIf="!(source === 'my-products' || catalogues?.length)" class="form-control" autocomplete="chrome-off"><!-- Placeholder to keep layout while invisible -->
				<input *ngIf="(source === 'my-products' || catalogues?.length) && modal?.isOpen" type="search" class="form-control" placeholder="Search" [(ngModel)]="search" (ngModelChange)="refreshProducts(500)" autocomplete="chrome-off" spellcheck="false" appDesktopFocus>
			</div>
			<div *ngIf="source !== 'my-products' && catalogues?.length" class="input-group ml-3 mb-2 flex-weight-1">
				<div class="input-group-prepend"><span class="input-group-text">Catalogue</span></div>
				<select class="custom-select" [(ngModel)]="selectedCatalogue" (ngModelChange)="catalogueChange()">
					<option *ngFor="let c of catalogues" [ngValue]="c">{{c.name}}</option>
				</select>
			</div>
		</div>

		<ui-grid-row class="product-grid mb-4">
			<ui-grid-col class="mr-2" *ngIf="data?.groups.length > 0">
				<!-- Categories -->
				<ui-card widget [wait]="data" [customHeaderDivider]="false">
					<div *ngIf="data" class="mt-n3 mb-2">
						<ui-tree [data]="categoryTree"></ui-tree>
					</div>
				</ui-card>
			</ui-grid-col>

			<ui-grid-col weight-3>
				<div class="d-flex flex-row border-bottom" *ngIf="data?.list && (source === 'my-products' || selectedCatalogue)">
					<div class="d-flex flex-column flex-weight-1">
						<div class="d-flex">
							<div *ngFor="let t of tabList" class="px-3 py-3 flex-weight-1 hoverable align-items-center selectable" [ngClass]="{ 'border-primary border-4 text-bold border-bottom': activeTab === t.id, 'border-lightgrey': activeTab !== t.id , 'd-none': !t.show, 'd-flex': t.show}" (click)="tabChange(t)">
								<span class="text-uppercase text-small text-bold mr-2" [ngClass]="{ 'text-secondary': activeTab !== t.id }"><i class="mr-2" [ngClass]="t.icon"></i>{{t.title}}</span>
							</div>
						</div>
					</div>
				</div>

				<div class="mb-2 scrollable flex-weight-1" [appTutorial]="505">
					<table *ngIf="data?.list && (source === 'my-products' || selectedCatalogue)" class="table table-hover vam">
						<thead>
							<tr *ngIf="app.orgInfo?.show_stock_level">
								<th colspan="2" class="sticky">Product</th>
								<th class="sticky text-center shrink nowrap">Stock Available</th>
								<th class="sticky text-center shrink nowrap">Stock On Order</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let item of data.list.result" class="selectable" [ngClass]="{ 'table-success': isItemSelected(item) || isRecentlyAddedProduct(item.id) || (replacementProduct && replacementProduct.id === item.id), dimmed: refreshAction.isPending() }" (click)="selectItem(item)" style="position: relative;">
								<td class="shrink pr-0">
									<div class="d-flex align-items-center justify-content-center">
										<span *ngIf="isRecentlyAddedProduct(item.id)" class="btn-success btn d-inline-block rounded-circle p-1 text-center mr-2" style="min-width: 1.5rem;">{{getAddedProducts(item.id).quantity}}</span>
										<div *ngIf="item.image_url" class="product-image mr-3" [style.backgroundImage]="'url(\'' + item.image_url + '\')' | safeStyle"></div>
									</div>
								</td>
								<td class="pl-0">
									<div *ngIf="item.short_description" class="text-bold">{{item.short_description}}</div>
									<div *ngIf="item.manufacturer_name || item.model" class="text-secondary">{{item.manufacturer_name}} {{item.manufacturer_name && item.model ? '/' : ''}} {{item.model}}</div>
									<div *ngIf="item.sku || item.manufacturer_sku" class="text-secondary text-tiny">{{item.sku || item.manufacturer_sku}}</div>
									<div *ngIf="item.special_order" class="text-warning"><i class="wq wq-warning"></i> Special order item</div>
								</td>
								<td *ngIf="app.orgInfo?.show_stock_level" class="text-center shrink nowrap">
									<span *ngIf="item.stock_level !== null" class="badge px-3" [ngClass]="(item.stock_level > 0) ? 'badge-success' : 'badge-danger'">{{item.stock_level}}</span>
								</td>
								<td *ngIf="app.orgInfo?.show_stock_level" class="text-center shrink nowrap">
									<span *ngIf="item.stock_ordered !== null" class="badge px-3" [ngClass]="(item.stock_ordered > 0) ? 'badge-success' : 'badge-danger'">{{item.stock_ordered}}</span>
								</td>
							</tr>
							<tr *ngIf="!pagination.count">
								<td [attr.colspan]="app.orgInfo?.show_stock_level ? 4 : 2" class="text-secondary">No products found.</td>
							</tr>
						</tbody>
					</table>

					<div *ngIf="!data?.list" class="w-100 h-100 d-flex align-items-center justify-content-center">
						<div class="spinner-border text-secondary"></div>
					</div>

					<div *ngIf="data?.list && (source !== 'my-products' && !catalogues?.length)" class="w-100 h-100 d-flex align-items-center justify-content-center">
						<p class="text-secondary">You don't have any catalogues linked to your account.</p>
					</div>

					<div *ngIf="data?.list && (source !== 'my-products' && catalogues?.length && selectedCatalogue === null)" class="w-100 h-100 d-flex align-items-center justify-content-center">
						<p class="text-secondary">Please select a catalogue.</p>
					</div>
				</div>
			</ui-grid-col>
		</ui-grid-row>

		<app-pagination [ngClass]="{ 'invisible': !(data?.list && (source === 'my-products' || selectedCatalogue)) }" [pagination]="pagination" (navigate)="refresh(100)"></app-pagination>
	</ng-container>

	<ng-container *ngIf="source === 'selected'">
		<div class="mb-2 scrollable flex-weight-1">
			<table *ngIf="multiSelectList.length" class="table table-hover vam">
				<tbody>
					<tr *ngFor="let item of multiSelectList" class="selectable table-success" (click)="selectItem(item)">
						<td class="shrink pr-0">
							<div *ngIf="item.image_url" class="product-image mr-3" [style.backgroundImage]="'url(\'' + item.image_url + '\')' | safeStyle"></div>
						</td>
						<td class="pl-0">
							<div *ngIf="item.short_description" class="text-bold">{{item.short_description}}</div>
							<div *ngIf="item.manufacturer_name || item.model" class="text-secondary">{{item.manufacturer_name}} {{item.manufacturer_name && item.model ? '/' : ''}} {{item.model}}</div>
							<div *ngIf="item.sku || item.manufacturer_sku" class="text-secondary text-tiny">{{item.sku || item.manufacturer_sku}}</div>
						</td>
					</tr>
				</tbody>
			</table>
			<p *ngIf="!multiSelectList.length" class="text-secondary">No products selected.</p>
		</div>
	</ng-container>

	<button class="btn btn-primary" *ngIf="app.orgInfo.role.manage_products && source === 'my-products'" (click)="openNewProductModal()" ui-modal-footer><i class="wq wq-add mr-2"></i>Add new product</button>
	<div class="flex-weight-1" ui-modal-footer></div>
	<button class="btn btn-secondary" (click)="modal.close()" ui-modal-footer>{{staysOpen ? 'Close' : 'Cancel'}}</button>
	<button *ngIf="replacementProduct" class="btn btn-success" (click)="modal.close(replacementProduct)" ui-modal-footer>Replace Product</button>
	<button *ngIf="isMulti" class="btn btn-success" (click)="addProductsButton()" [disabled]="!multiSelectList.length" ui-modal-footer><i class="wq wq-add mr-1"></i>Add Selected Products <ui-button-badge>{{multiSelectList.length}}</ui-button-badge></button>
</ui-modal>

<ng-template (close)="newProductModalClosed($event)" modalEditProduct></ng-template>
